import { cn } from '../../lib/utils';
import { Skeleton } from '../ui/skeleton';

export const DataTable = ({
  columns,
  data,
  loading,
  emptyMessage = 'No data available',
  className,
  rowClassName,
  onRowClick,
}) => {
  if (loading) {
    return (
      <div className={cn("data-card overflow-hidden", className)} data-testid="data-table-loading">
        <div className="overflow-x-auto">
          <table className="data-table">
            <thead>
              <tr className="border-b border-white/10">
                {columns.map((col, i) => (
                  <th key={i} className={col.headerClassName}>
                    {col.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(5)].map((_, i) => (
                <tr key={i}>
                  {columns.map((_, j) => (
                    <td key={j}>
                      <Skeleton className="h-4 w-full" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className={cn("data-card p-8 text-center", className)} data-testid="data-table-empty">
        <p className="text-muted-foreground">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={cn("data-card overflow-hidden", className)} data-testid="data-table">
      <div className="overflow-x-auto scrollbar-thin">
        <table className="data-table">
          <thead>
            <tr className="border-b border-white/10">
              {columns.map((col, i) => (
                <th key={i} className={cn(col.headerClassName)}>
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr
                key={row.id || i}
                className={cn(
                  "table-row-enter",
                  onRowClick && "cursor-pointer",
                  rowClassName
                )}
                onClick={() => onRowClick?.(row)}
                style={{ animationDelay: `${i * 0.05}s` }}
              >
                {columns.map((col, j) => (
                  <td key={j} className={cn(col.cellClassName)}>
                    {col.cell ? col.cell(row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
